import React from 'react';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import Collapsible from 'react-collapsible';
import Border from "./Border";
import { renderDragIcon } from '../utils/renderDragIcon';
import Toggle from './sectioninputs/Toggle';

export default class LayoutEditor extends React.Component {
  handleDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }

    const {layout, onChange} = this.props;
    const updatedLayout = [...layout];
    const movingItemIndex = updatedLayout.findIndex((item, idx) => {
      const group = layout.filter(i => i.position === source.droppableId);
      return item === group[source.index];
    });

    if (movingItemIndex === -1) {
      return;
    }

    const [movedItem] = updatedLayout.splice(movingItemIndex, 1);
    movedItem.position = destination.droppableId;

    const reordered = [];
    let insertIndex = 0;

    for (let i = 0; i < updatedLayout.length; i++) {
      const current = updatedLayout[i];
      if (current.position === destination.droppableId) {
        if (insertIndex === destination.index) {
          reordered.push(movedItem);
        }
        reordered.push(current);
        insertIndex++;
      } else {
        reordered.push(current);
      }
    }

    if (!reordered.includes(movedItem)) {
      reordered.push(movedItem);
    }

    onChange(reordered);
  };

  renderDroppable = (position, title, fullWidth = false) => {
    const blocks = this.props.layout.filter(b => b.position === position);
    const containerClass = fullWidth ? "col-12" : "col-md-6";

    return (
      <div className={containerClass}>
        <h5 className="mb-1 mt-1 text-center" style={{fontWeight: 600}}>{title}</h5>
        <Droppable droppableId={position}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="droppable-zone"
              style={{
                backgroundColor: snapshot.isDraggingOver ? "#e3f2fd" : "#f8f9fa",
                border: snapshot.isDraggingOver ? "2px dashed #2196f3" : "1px solid #dee2e6",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "6px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {blocks.map((block, index) => this.renderDraggable(block, index))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  };

  renderDraggable = (block, index) => {
    return (
      <Draggable key={block.key} draggableId={block.key} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              border: "1px solid #ccc",
              padding: "8px 12px",
              background: snapshot.isDragging ? "#e0f7fa" : "#fff",
              borderRadius: "4px",
              fontSize: "14px",
              boxShadow: snapshot.isDragging ? "0 2px 8px rgba(0,0,0,0.15)" : "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "grab",
              ...provided.draggableProps.style,
            }}
          >
            <div style={{ flexGrow: 1, textAlign: "left" }}>
              {block.label}
            </div>

            {renderDragIcon({}, "inline")}
          </div>
        )}
      </Draggable>
    );
  };

  render() {
    const {defaultLayout, onReset, data} = this.props;
    return (
      <Border>
        <Collapsible trigger={this.props.title} className="mb-3">
          <br/>
          <Toggle
            id="toggle_quick_settings_element_highlight"
            checked={data.display_quick_settings_element_highlight ?? true}
            title="Display Element Highlight"
            tooltip='Show an outline when hovering over page elements This will only show while editing the page.'
            onChange={checked => {
              data.display_quick_settings_element_highlight = checked
              this.props.onUpdated(data)
            }}
          />
          <DragDropContext onDragEnd={this.handleDragEnd}>
            <div className="row">
              {this.renderDroppable("left", "Left Column")}
              {this.renderDroppable("right", "Right Column")}
            </div>
            <div className="row mt-4">
              {this.renderDroppable("row", "Full Width Below", true)}
            </div>
          </DragDropContext>
          {defaultLayout && (
            <div className="d-flex justify-content-end mt-4">
              <a
                className="btn btn--primary type--uppercase"
                style={{
                  background: "#fa6160",
                  borderColor: "#fa6160"
                }}
                onClick={onReset}
              >
              <span className="material-icons btn__text mr-1"
                    style={{
                      fontSize: "18px",
                      lineHeight: "1",
                      position: "relative",
                      top: "5px"
                    }}>
                restart_alt
              </span>
                <span className="btn__text">
                  Use Default Layout
                </span>
              </a>
            </div>
          )}
        </Collapsible>
      </Border>
    );
  }
}
